import React from 'react';

interface Props {
  title?: string | null;
  messageText?: string | null;
}

export default function TitleOverlay({ title, messageText }: Props): React.ReactElement | null {
  if (!title && !messageText) {
    return null;
  }

  return (
    <div className="video-title-overlay">
      {title ? (
        <h2 className="title-overlay">{title}</h2>
      ) : messageText ? (
        <h2 className="title-overlay">{messageText}</h2>
      ) : null}
    </div>
  );
}
